export default __webpack_public_path__ + "static/media/ac-ser.58de71a4.png";